module.exports = __webpack_public_path__ + "static/media/img-home6.f244cfd1.jpg";